export const PATHS = {
  connectedApps: 'apps',
  profile: 'profile',
};
